<template>
    <el-dialog
      title="错误源代码"
      :visible.sync="codeDialogVisible"
      width="80%"
    >

      <stack-code :stack="stack" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="codeDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="codeDialogVisible = false" size="small">确 定</el-button>
      </span>
    </el-dialog>
</template>
<script>
import StackCode from './code.vue';

export default {
  components: {
    StackCode,
  },
  props: {
    value: Boolean,
    stack: Array,
  },
  data() {
    return {
      codeDialogVisible: false,
    };
  },
  watch: {
    value(val) {
      this.codeDialogVisible = val;
    },
    codeDialogVisible(val) {
      this.$emit('input', val);
    },
  },
  mounted() {
    this.codeDialogVisible = this.value;
  },
};
</script>
<style scoped lang="scss">
.source-code {
  // padding: 20px;
  // background: #f9fafd;
  word-wrap: break-word;
  // border-radius: 5px;

  code {
    line-height: 1;
    color: #333;
    margin-bottom: 0;
  }

  pre {
    margin: 0;
    padding: 0;
    font-size: 12px;
    line-height: 1.2;
    text-align: left;
    box-sizing: content-box;
    // height: 20px;
    // line-height: 20px;
  }
}

.line-item {
  // display: flex;
  // >span {
  //   display: block;
  // }
}

.code-line-number {
  margin-right: 10px;
  position: absolute;
  left: 0;
  top: -1px;
}
.code-line {
  text-align: left;
  padding: 0px;
  position: relative;
  // margin-bottom: 5px;
  // height: 20px;
  color: #333;
  line-height: 20px;
}

.hight-line {
  // background-color: #ffadad;
  color: #f85149;
}
</style>
